import { motion } from 'framer-motion'
import LanguageSwitcher from './LanguageSwitcher'
import { useI18n } from '../lib/i18n'

interface NavbarDesktopProps {
  isVisible: boolean
}

export default function NavbarDesktop({ isVisible }: NavbarDesktopProps) {
  const { t } = useI18n()
  return (
    <motion.nav
      className="nav-container fixed top-[3vh] left-[5vw] right-[5vw] z-50 flex items-center justify-between bg-white rounded-xl shadow-sm px-[2vw] py-[1.5vh]"
      initial={{ y: -20, opacity: 0 }}
      animate={{
        y: isVisible ? 0 : -120,
        opacity: isVisible ? 1 : 0
      }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      {/* LOGO */}
      <a href="/">
        <motion.img
          src="/Logo.png"
          alt="Logo"
          crossOrigin="anonymous"
          className="logo h-[4.5vh] object-contain cursor-pointer"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
        />
      </a>

      {/* Navigation Links */}
      <div className="flex items-center gap-[2.5vw]">
        <motion.a
          href="/valet-parken-frankfurt-flughafen"
          className="nav-link text-[1.6vh] font-medium text-gray-700 hover:text-[#0052CC] transition-colors"
          whileHover={{ y: -2, color: '#00BCC5' }}
          transition={{ duration: 0.2 }}
        >
          {t.nav.parking}
        </motion.a>
        <motion.a
          href="/flughafen-frankfurt-preise"
          className="nav-link text-[1.6vh] font-medium text-gray-700 hover:text-[#0052CC] transition-colors"
          whileHover={{ y: -2, color: '#00BCC5' }}
          transition={{ duration: 0.2 }}
        >
          {t.nav.prices}
        </motion.a>
        <motion.a
          href="/kontakt-valet-parken-frankfurt"
          className="nav-link text-[1.6vh] font-medium text-gray-700 hover:text-[#0052CC] transition-colors"
          whileHover={{ y: -2, color: '#00BCC5' }}
          transition={{ duration: 0.2 }}
        >
          {t.nav.contact}
        </motion.a>
        <motion.a
          href="/fragen-antworten-flughafenparkplatz-frankfurt"
          className="nav-link text-[1.6vh] font-medium text-gray-700 hover:text-[#0052CC] transition-colors"
          whileHover={{ y: -2, color: '#00BCC5' }}
          transition={{ duration: 0.2 }}
        >
          {t.nav.faq}
        </motion.a>
      </div>

      {/* Right Side: Language Switcher + CTA */}
      <div className="flex items-center gap-[1.5vw]">
        {/* Language Switcher */}
        <LanguageSwitcher variant="desktop" />

        {/* CTA Button */}
        <motion.button
          className="cta-button bg-[#0052CC] text-white px-[1.8vw] py-[1vh] text-[1.5vh] font-medium rounded-full shadow-md"
          whileHover={{
            scale: 1.03,
            backgroundColor: '#0747A6',
            boxShadow: '0px 10px 20px rgba(0, 82, 204, 0.3)'
          }}
          whileTap={{ scale: 0.98 }}
          transition={{ duration: 0.2 }}
          onClick={() => {window.location.href = '/buchen'}}
        >
          {t.nav.book}
        </motion.button>
      </div>
    </motion.nav>
  )
}
